// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import {Model as SequencePrimer} from 'biojs/SequencePrimer';
import {Sequence} from 'components/Sequence';
import {CRISPRAnalysis} from 'constants/CRISPRConstants';
import SearchDNAData from 'molbio/biological-search/SearchDNAData';
import {TabState, TabStateDefaults} from 'Navigation';

// @ts-expect-error
import CRISPRAnalysisActions from './CRISPRAnalysisActions';
import CRISPRAnalysisStore from './CRISPRAnalysisStore';

interface CRISPRAnalysisTabStateAttributes extends TabStateDefaults {
  guidePrimers: Array<SequencePrimer>;
  sequence: Sequence;
  search: SearchDNAData;
  analysisId: string;
}

interface CRISPRAnalysisTabState extends TabState {
  get<K extends keyof CRISPRAnalysisTabStateAttributes>(key: K): CRISPRAnalysisTabStateAttributes[K];
  set<K extends keyof CRISPRAnalysisTabStateAttributes>(
    attributeName: K,
    value: CRISPRAnalysisTabStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): CRISPRAnalysisTabState;
  set(obj: Partial<CRISPRAnalysisTabStateAttributes>): CRISPRAnalysisTabState;
}

class CRISPRAnalysisTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Design CRISPR',
      closeable: true,
    };
  }

  initialize(): void {
    if (!CRISPRAnalysisStore.isFullAnalysisId(this.analysisId())) {
      CRISPRAnalysisActions.open(this.analysisId());
    }

    const sequence = this.sequence();
    const search = new SearchDNAData();
    search.addSequences([sequence]);
    search.set({sequence});
    this.set({guidePrimers: [], search});

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const reanalyzeOnTargetOnce = debounce(this.reanalyzeOnTarget, 0);
    this.listenTo(sequence._sequence().translations(), 'add change remove reset', reanalyzeOnTargetOnce);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(sequence._sequence(), 'change:circular', this.recomputeAnalysisGuides);
  }

  sequence(): Sequence {
    return this.get('sequence');
  }
  analysisId(): string {
    return this.get('analysisId');
  }
  guidePrimers(): Array<SequencePrimer> {
    return this.get('guidePrimers');
  }
  search(): SearchDNAData {
    return this.get('search');
  }

  getAnalysis(): CRISPRAnalysis {
    const {analyses} = CRISPRAnalysisStore.getState();
    return analyses[this.analysisId()] as CRISPRAnalysis;
  }

  recomputeAnalysisGuides(): void {
    const analysis = this.getAnalysis();
    const findGuidesParams = {analysis, search: this.search(), sequence: this.sequence()};
    CRISPRAnalysisActions.recomputeGuides(analysis.id, findGuidesParams);
  }

  reanalyzeOnTarget(): void {
    const analysis = this.getAnalysis();
    if (analysis.useAzimuthOnTargetScore) {
      // eslint-disable-next-line no-restricted-syntax
      const regionIds = _.pluck(analysis.regions, 'id');
      CRISPRAnalysisActions.analyzeOnTargetBulk(analysis.id, regionIds);
    }
  }

  resetGuidePrimers(addGuidePrimers: Array<SequencePrimer>, options?: {empty?: boolean}): void {
    if (options == null) {
      options = {};
    }
    _.defaults(options, {empty: false});
    const sequencePrimers = this.sequence()._sequence().sequencePrimers();
    sequencePrimers.batchModify(() => {
      for (const primer of Array.from(this.guidePrimers())) {
        primer.destroy();
      }
      sequencePrimers.add(addGuidePrimers);
    });
    this.set({guidePrimers: options.empty ? [] : addGuidePrimers});
  }

  cleanUp(): void {
    this.stopListening();
    this.resetGuidePrimers([]);
  }
}

export default CRISPRAnalysisTabState;
